function formatterExternalLinkHtml(href: string, name: string): string | null {
  return `<span href="${href}" target="_blank" style="text-decoration: underline; color: #593ABC; font-weight: bold;">${name}</span>`;
}
export default formatterExternalLinkHtml;
